import { render } from "./service-repair-history.vue?vue&type=template&id=778abd10"
import script from "./service-repair-history.vue?vue&type=script&lang=js"
export * from "./service-repair-history.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__